import { render, staticRenderFns } from "./docSession.vue?vue&type=template&id=304707e6&scoped=true"
import script from "./docSession.vue?vue&type=script&lang=js"
export * from "./docSession.vue?vue&type=script&lang=js"
import style0 from "./docSession.vue?vue&type=style&index=0&id=304707e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304707e6",
  null
  
)

export default component.exports